"use client";

import { WorkHeading } from "./WorkHeading";
import { WorkIntro } from "./WorkIntro";
import { WorkGrid } from "./WorkGrid";
import { WorkSectionHeading } from "./WorkSectionHeading";
import { WorkContactCta } from "./WorkContactCta";
import { useData } from "@/i18n/LangContext";

export function WorkOverviewClient() {
  const data = useData();
  const { title, intro, previewNotAvailable, moreDetails, sections, contactCta, cases } = data.work;

  // Neueste zuerst; Einträge ohne Datum ans Ende
  const byDateDesc = (a: typeof cases[number], b: typeof cases[number]) =>
    (b.date ?? "").localeCompare(a.date ?? "");

  const appCases = cases.filter(c => c.category === "app").sort(byDateDesc);
  const blogCases = cases.filter(c => c.category !== "app").sort(byDateDesc);

  return (
    <div className="w-full max-w-6xl py-4 md:py-16 transition-all duration-400">
      <WorkHeading title={title} />
      <WorkIntro intro={intro} />

      {appCases.length > 0 && (
        <section data-cy="work-section-apps" className="mb-16">
          <WorkSectionHeading title={sections.apps.title} intro={sections.apps.intro} />
          <WorkGrid
            projects={appCases}
            previewNotAvailable={previewNotAvailable}
            moreDetailsText={moreDetails}
          />
        </section>
      )}

      <section data-cy="work-section-blog">
        <WorkSectionHeading title={sections.blog.title} intro={sections.blog.intro} />
        <WorkGrid
          projects={blogCases}
          previewNotAvailable={previewNotAvailable}
          moreDetailsText={moreDetails}
        />
      </section>

      <WorkContactCta
        text={contactCta.text}
        buttonText={contactCta.buttonText}
      />
    </div>
  );
}
